import { render, staticRenderFns } from "./CommonCard.vue?vue&type=template&id=62cc6a1e&scoped=true&"
import script from "./CommonCard.vue?vue&type=script&lang=js&"
export * from "./CommonCard.vue?vue&type=script&lang=js&"
import style0 from "./CommonCard.vue?vue&type=style&index=0&id=62cc6a1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cc6a1e",
  null
  
)

export default component.exports